import { render, staticRenderFns } from "./WidgetGroupManagement.vue?vue&type=template&id=15073384&"
import script from "./WidgetGroupManagement.vue?vue&type=script&lang=js&"
export * from "./WidgetGroupManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports